var _circle, _path, _circle2, _circle3, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#201E26"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3707 15.7268C16.1387 15.5145 15.8504 15.3574 15.5359 15.3574H14.3926C14.0781 15.3574 13.7898 15.5145 13.5578 15.7268C13.0814 16.1629 12.4467 16.4289 11.75 16.4289C11.1079 16.4289 10.5186 16.203 10.0572 15.8263C9.76731 15.5896 9.38991 15.4156 9.05978 15.5918C8.42917 15.9283 8 16.5927 8 17.3574V23.0002C8 24.1048 8.89543 25.0002 10 25.0002H19.9285C21.0331 25.0002 21.9285 24.1048 21.9285 23.0002V17.3574C21.9285 16.5927 21.4994 15.9283 20.8688 15.5918C20.5386 15.4156 20.1612 15.5896 19.8714 15.8263C19.41 16.203 18.8206 16.4289 18.1786 16.4289C17.4818 16.4289 16.8472 16.1629 16.3707 15.7268Z",
    fill: "#A1A3B2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.7499,
    cy: 12.6786,
    r: 1.92856,
    stroke: "white",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1786,
    cy: 12.6786,
    r: 1.92856,
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8001 16.1828L22.9787 17.7502C22.6612 17.9266 22.4644 18.2612 22.4644 18.6244V21.1361C22.4644 21.5313 22.6971 21.8894 23.0582 22.0499L25.8796 23.3039C26.5409 23.5978 27.2858 23.1137 27.2858 22.3901V17.0569C27.2858 16.2945 26.4667 15.8125 25.8001 16.1828Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video_icon.c3d994ce82569ac2c6da2a503ef5c4f7.svg";
export { ForwardRef as ReactComponent };